module.exports = __webpack_public_path__ + "img/bao-cao-thong-ke-icon.3ba0138a.svg";